export const modalWidth = '21rem';